export default __webpack_public_path__ + "static/image9-82879d32beea75613bb8f0bef1f160aa.jpg";